<template>
  <div class="destination-box">
    <div class="header">
      <label class="switch">
        <input type="checkbox" v-model="showForm" />
        <span class="slider"></span>
      </label>
      <span class="title">Destination</span>
    </div>

    <transition name="fade">
      <div v-if="showForm">
        <div class="form-group" :class="{ 'has-error': submitted && !form.websiteUrl }">
          <label>Website URL <span class="required">*</span></label>
          <input type="text" v-model="form.websiteUrl" placeholder="Enter website URL" />
          <p class="note">*This URL is required for all platforms</p>
        </div>

        <div class="form-group">
          <label>Deep link <span class="required">*</span></label>
          <input type="text" v-model="form.deepLink" placeholder="Enter the link that you want to show on your ad" />
        </div>

        <div class="form-group" :class="{ 'has-error': submitted && !form.cta }">
          <label class="required">Call to action <span class="required">*</span></label>
          <v-select v-model="form.cta" :items="ctaoptions" variant="outlined" placeholder="select action"
            density="compact" hide-details style="width: 100%" />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { useSuperAddStore } from "@/store/superAddStore";

export default {
  name: "DestinationSection",
  data() {
    return {
      submitted: false,
      ctaoptions: ["Apply now", "Shop now"],
      attachmentoption: ["Web view", "App link"],
      store: useSuperAddStore(),
    };
  },
  computed: {
    form() {
      return this.store.adCreativeData;
    },
    showForm: {
      get() {
        return this.store.adCreativeData.showDestination;
      },
      set(val) {
        this.store.adCreativeData.showDestination = val;
      },
    },
  },
  methods: {
    validate() {
      this.submitted = true;
      const errors = [];

      if (this.showForm) {
        if (!this.form.websiteUrl) errors.push("Website URL is required");
        if (!this.form.deepLink) errors.push("deepLink URL is required");
        if (!this.form.cta) errors.push("Call to action is required");
      }

      return errors;
    },
    getData() {
      return this.showForm
        ? {
          attachmentType: this.form.attachmentType,
          websiteUrl: this.form.websiteUrl,
          deepLink: this.form.deepLink,
          cta: this.form.cta,
        }
        : null;
    },
  },
};
</script>

<style scoped>
.destination-box {
  background: white;
  border-radius: 16px;
  padding: 32px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08);
  margin: 30px auto;
}

.header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
}

.title {
  font-size: 20px;
  font-weight: 600;
}

.switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 20px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 20px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 14px;
  width: 14px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

.switch input:checked+.slider {
  background-color: #00675f;
}

.switch input:checked+.slider:before {
  transform: translateX(20px);
}

.form-group {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}

label {
  font-weight: 500;
  margin-bottom: 8px;
  color: #222;
  font-size: 14px;
}

.required {
  color: red !important;
}

input,
select {
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #ddd;
  font-size: 14px;
  background-color: #fafafa;
}

.has-error input,
.has-error select,
.has-error label {
  border-color: red !important;
  color: red !important;
}

.note {
  font-size: 12px;
  color: red;
  margin-top: 4px;
  display: none;
}

.has-error .note {
  display: block !important;
}

.footer {
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
}

.btn {
  padding: 10px 24px;
  border: none;
  border-radius: 8px;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.btn.back {
  background-color: #f3f3f3;
  color: #333;
}

.btn.publish {
  background-color: #00675f;
  color: white;
}

@media (max-width: 768px) {
  .destination-box {
    padding: 24px;
  }

  .footer {
    flex-direction: column;
    gap: 12px;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

::v-deep(.v-field__outline) {
  display: none !important;
}

::v-deep(.v-input--horizontal) {
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 0.25rem;
}

::v-deep(.v-text-field .v-field__outline) {
  display: none !important;
}

::v-deep(.v-field__field) {
  min-width: 5rem;
}
</style>
